import React, { useEffect } from "react";
import { Button, TextField } from "@mui/material";
import { Image } from "mui-image";
import { useSearchParams } from "react-router-dom";
import BUSINESSACCOUNT from "../../assets/images/business-account.svg";
import CUSTOMERACCOUNT from "../../assets/images/customer-account.svg";

import EXPERT from "../../assets/images/expert.svg";
import BRAND from "../../assets/images/brand.svg";
import CENTRE from "../../assets/images/center.svg";

import { apiCall, preloadImage } from "../../utils/helpers";
import About from "./customer/About";
import { useState } from "react";
import Interests from "./customer/Interests";
import StageOneComplete from "./customer/StageOneComplete";
import HealthQuestions from "./customer/HealthQuestions";
import HealthScore from "./customer/HealthScore";
import { MainContext } from "../../utils/context";
import DownloadApp from "./customer/DownloadApp";
import ExpertDetails from "./ExpertDetails";

const accountType = [
  {
    id: 1,
    account_type_name: "business",
    title: "I'm here for business",
    img: BUSINESSACCOUNT,
  },
  {
    id: 2,
    account_type_name: "personal",
    title: "I'm here for my health",
    img: CUSTOMERACCOUNT,
  },
];

const typeArray = [
  { admin_type_id: 1, admin_type_name: "expert" },
  { admin_type_id: 2, admin_type_name: "brand" },
  { admin_type_id: 3, admin_type_name: "centre" },
];

const ismobile = window.innerWidth <= 768;

export default function AccountTypeSelect({
  setIsCustomer,
  selectedType = {},
  setSelectedType = () => {},
  accountTypeSubmitHandler = () => {},
  isInvitedByExpert = false,
  typeIndex,
  setTypeIndex,
  data = {},
  userType = "",
}) {
  const [searchParams] = useSearchParams();
  const expertId = searchParams.get("expert_id");
  const { setMsg } = React.useContext(MainContext);
  const [step, setStep] = useState(1);
  const [selectedAccountType, setSelectedAccountType] = useState({
    id: 1,
    account_type_name: "business",
    title: "I'm here for business",
    img: BUSINESSACCOUNT,
  });
  const [verifying, setVerifying] = useState(false);

  // state to store onboarding user from verifyOtp response;
  const [onBoardingUser, setOnboardingUser] = useState(data);

  const [types, setTypes] = useState(typeArray);
  React.useEffect(() => {
    getAccountTypes();
    if (onBoardingUser?.is_newuser === 1) {
      setStep(1);
    } else {
      // setStep(8);
      setStep(9);
    }
  }, []);

  useEffect(() => {
    userType === "brand" || userType === "centre"
      ? setStep(2)
      : userType === "user"
      ? setStep(3)
      : setStep(1);
  }, []);

  const getAccountTypes = () => {
    apiCall
      .post("v1/user/getAdminTypes", {
        api_name: "getAdminTypes",
        key: "JWT",
        secret: "DOPAMINE",
      })
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          setTypes(res.data.data);
          res.data.data.forEach((type) => {
            preloadImage(type.inactive_icon);
            preloadImage(type.active_icon);
            return type;
          });
        }
      })
      .catch((err) => console.log(err));
  };

  const stepOneHandler = () => {
    if (selectedAccountType?.account_type_name === "business") {
      setStep(2);
    } else if (onBoardingUser?.is_newuser === 0 && isInvitedByExpert === true) {
      setStep(3);
    } else {
      // document.location.href = 'https://onelink.to/5z9d3p'
      // register onboading user here and update onBoardingUser state;
      setVerifying(true);
      apiCall
        .post("v1/user/createCustomer", {
          api_name: "createCustomer",
          // key: "JWT",
          // secret: "DOPAMINE",
          user_id: onBoardingUser?.user_id,
          auth: onBoardingUser?.token,
          // expert_id: onBoardingUser?.expert_id,
        })
        .then((res) => {
          if (res.status === 200 && res.data.success) {
            // setOnboardingUser(res?.data?.data);
            setVerifying(false);
            setMsg(res?.data?.msg);
            setStep(3);
          } else {
            setVerifying(false);
            setMsg(res?.data?.msg);
            if (res?.data?.msg === "Customer already exist!") {
              setStep(9);
            }
          }
        })
        .catch((err) => {
          console.log(err);
          setVerifying(false);
        });
    }
  };

  const createCustomerHandler = () => {
    setStep(step + 1);
  };

  // input fields states
  const [error, setError] = useState({
    brandName: false,
    centreName: false,
    centreAddress: false,
  });
  const [brandName, setBrandName] = useState("");
  const [centreName, setCentreName] = useState("");

  // customer states and functions
  const [aboutObj, setAboutObj] = useState({
    firstName: onBoardingUser?.first_name || "",
    lastName: onBoardingUser?.last_name || "",
    dob: onBoardingUser?.dob || "",
    gender: onBoardingUser?.gender || "male",
    weight: onBoardingUser?.height || 50,
    height: onBoardingUser?.weight || 150,
  });
  const [selectedSubTypes, setSelectedSubTypes] = useState([]);
  const [healthQuestions, setHealthQuestions] = useState([]);
  const [score, setScore] = React.useState(0);
  const [scorePercentage, setScorePercentage] = React.useState(0);
  const [tag, setTag] = React.useState("");

  const [onBoardingData, setOnBoardingData] = useState([]);
  const [questionIndex, setQuestionIndex] = useState(0);
  const [type, setType] = useState("");

  // update customer profile (about and interests)
  const updateCustomerHandler = () => {
    setVerifying(true);
    apiCall
      .post("v1/user/editProfile", {
        api_name: "editProfile",
        // key: "JWT",
        // secret: "DOPAMINE",
        auth: onBoardingUser?.token,
        user_id: onBoardingUser?.user_id,
        type: "customer",
        first_name: aboutObj?.firstName,
        last_name: aboutObj?.lastName,
        height: aboutObj?.height,
        weight: aboutObj?.weight,
        gender: aboutObj?.gender,
        dob: aboutObj?.dob,
        interests: selectedSubTypes?.map((selected) => {
          return selected?.category_id;
        }),
      })
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          setType("training_mode");

          setVerifying(false);
          setStep(5);
          getCustomerOnboardingData({
            user_type: "customer",
          });
        } else {
          setVerifying(false);
          setMsg(res?.data?.msg);
        }
      })
      .catch((err) => {
        console.log(err);
        setVerifying(false);
      });
  };

  //Update customer profile(questionaires)

  const updateProfile = (user_type, question_id, selectedData, other) => {
    setVerifying(true);
    let payload = {
      user_id: data.user_id,
      option_id: selectedData,
      question_id,
      user_type,
      other,
      api_name: "postUserOnboardingResponse",
    };
    apiCall
      .post("v2/user/postUserOnboardingResponse", payload)
      .then((res) => {
        console.log("Data saved", res?.data.data);

        if (res?.data?.success) {
          setVerifying(false);
          if (onBoardingData.length - 1 === questionIndex) {
            setMsg("Details captured successfully");

            // setStep((prev) => prev + 1);
          }

          // getCustomerOnboardingData({
          //   user_type: "customer",
          // });

          // indexNum === 0
          //   ? getCustomerOnboardingData({
          //       type: "payment",
          //     })
          //   : indexNum === 1
          //   ? getCustomerOnboardingData({
          //       type: "preference",
          //     })
          //   : getCustomerOnboardingData();
        } else {
          setVerifying(false);
          setMsg(res?.data?.msg);
        }
      })
      .catch((err) => {
        console.log(err);
        setVerifying(false);
      });
  };

  // get healthscore
  const getHealthScoreHandler = () => {
    setVerifying(true);
    apiCall
      .post("v1/dopamine/getHealthscore", {
        api_name: "getHealthscore",
        // key: "JWT",
        // secret: "DOPAMINE",
        auth: onBoardingUser?.token,
        user_id: onBoardingUser?.user_id,
        health_score: healthQuestions.map((question) => ({
          question_id: question.question_id,
          answer: question?.answer,
        })),
      })
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          setScore(res?.data?.data?.health_score);
          setScorePercentage(res?.data?.data?.percentage);
          if (
            res?.data?.data?.health_score >= 50 &&
            res?.data?.data?.health_score <= 250
          ) {
            setTag("worst");
          } else if (
            res?.data?.data?.health_score >= 300 &&
            res?.data?.data?.health_score <= 500
          ) {
            setTag("bad");
          } else if (res?.data?.data?.health_score === 500) {
            setTag("neutral");
          } else if (
            res?.data?.data?.health_score >= 550 &&
            res?.data?.data?.health_score <= 700
          ) {
            setTag("good");
          } else if (
            res?.data?.data?.health_score >= 750 &&
            res?.data?.data?.health_score <= 950
          ) {
            setTag("great");
          }
          setVerifying(false);
        } else {
          setVerifying(false);
          setMsg(res?.data?.msg);
        }
      })
      .catch((err) => {
        console.log(err);
        setVerifying(false);
      });
  };

  console.log("selectedType.admin_type_id-------", selectedType.admin_type_id);

  // useEffect(() => {
  //   userType === "" && setSelectedType({ admin_type_id: 1 });
  // }, []);
  React.useEffect(() => {
    if (expertId) {
      setSelectedAccountType(accountType[1]);
    }
  }, [expertId]);
  React.useEffect(() => {
    if (expertId) {
      stepOneHandler();
    }
  }, [selectedAccountType]);

  let questions = [
    "How do you train yourself ?",
    "How much do you spend per month on fitness?",
    "What do you prefer for your fitness?",
  ];

  const getCustomerOnboardingData = (payload) => {
    setVerifying(true);
    apiCall
      .post("v2/user/getUserOnboardingData", {
        ...payload,
        api_name: "getUserOnboardingData",
      })
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          setVerifying(false);
          setOnBoardingData(res.data.data);
        } else {
          setVerifying(false);
          setMsg(res?.data?.msg);
        }
      })
      .catch((err) => {
        console.log(err);
        setVerifying(false);
      });
  };

  return (
    <>
      {step === 1 ? (
        <div
          className="onboarding-step onboarding-step-1"
          style={{ padding: "1.5rem" }}
        >
          <p
            style={{
              margin: "20px 0 30px 0",
              fontSize: "26px",
              fontWeight: 700,
              color: "#CFCFCF",
              textAlign: "center",
            }}
          >
            {/* What you want to achieve with our platform */}
            Select type of your account
          </p>

          {accountType?.map((type, index) => (
            <div
              style={{
                padding: "1px",
                borderRadius: "8px",
                margin: "1rem 0",
                background:
                  "linear-gradient(152.68deg, #FFFFFF 5.46%, rgba(255, 255, 255, 0) 32.84%, rgba(255, 255, 255, 0) 71.3%, #FFFFFF 100%)",
              }}
            >
              <div
                key={index}
                onClick={() => {
                  setSelectedAccountType(type);
                  type.account_type_name === "personal"
                    ? setIsCustomer(true)
                    : setIsCustomer(false);
                }}
                className={`request-type ${
                  type.account_type_name ===
                    selectedAccountType.account_type_name && "selected-type"
                }`}
                style={{
                  justifyContent: "space-between",
                  padding: "24px",
                  margin: 0,
                  // border: " 1px solid",

                  // borderImage:
                  //   "linear-gradient(141.77deg, #D2D2D2 3.04%, rgba(210, 210, 210, 0) 41.75%, rgba(210, 210, 210, 0) 59.21%, #D2D2D2 93.74%)",

                  // border: "1px solid",

                  // borderImageSource:
                  //   "linear-gradient(141.77deg, #D2D2D2 3.04%, rgba(210, 210, 210, 0) 41.75%, rgba(210, 210, 210, 0) 59.21%, #D2D2D2 93.74%)",
                }}
              >
                <div
                  style={{
                    fontWeight: "700",
                    fontSize: "20px",
                    maxWidth: ismobile ? 122 : "",
                    // textTransform: "capitalize",
                  }}
                >
                  <p
                    style={{
                      fontSize: "14px",
                      textTransform: "uppercase",
                      color:
                        type.account_type_name === "business"
                          ? type.account_type_name ===
                            selectedAccountType.account_type_name
                            ? "#FFFFFF"
                            : "#FF4A01"
                          : type.account_type_name ===
                            selectedAccountType.account_type_name
                          ? "#FFFFFF"
                          : "#1F76F9",
                      marginTop: 0,
                      marginBottom: 28,
                      letterSpacing: "0.14em",
                    }}
                  >
                    {`${type.account_type_name} account`}
                  </p>

                  {type.title}
                </div>
                <div>
                  <Image
                    height="90px"
                    width="90px"
                    fit="contain"
                    duration={800}
                    src={type?.img}
                    alt=""
                  />
                </div>
              </div>
              {/* {index === 0 && (
                <p
                  style={{
                    margin: "12px 0",
                    fontSize: 20,
                    fontWeight: 500,
                    color: "#222831",
                    textAlign: "center",
                  }}
                >
                  Or
                </p>
              )} */}
            </div>
          ))}
        </div>
      ) : step === 2 ? (
        userType === "brand" ? (
          <div
            className="onboarding-step onboarding-step-2"
            style={{ padding: "1.5rem", color: "#CFCFCF" }}
          >
            <p
              style={{
                margin: "20px 0 40px 0",
                fontSize: "24px",
                fontWeight: 600,
                textAlign: "center",
              }}
            >
              Enter the brand name
            </p>
            <div style={{ margin: "1rem 0" }}>
              {/* {types.map((type, index) => ( */}
              <div
                // key={type.admin_type_id}
                style={{ marginBottom: "2rem" }}
              >
                {/* <div
                  style={{
                    margin: "1rem 0px",
                    borderRadius: "8px",

                    background:
                      "linear-gradient(152.68deg, #FFFFFF 5.46%, rgba(255, 255, 255, 0) 32.84%, rgba(255, 255, 255, 0) 71.3%, #FFFFFF 100%)",
                    padding: "1px",
                  }}
                >
                  <div
                    style={{
                      color:
                        type.admin_type_id === selectedType.admin_type_id
                          ? "#272727"
                          : "#FFFFFF",

                      margin: 0,

                      // background:type.admin_type_id === selectedType.admin_type_id"#1f1f1f":
                    }}
                    onClick={() => setSelectedType(type)}
                    className={`request-type ${
                      type.admin_type_id === selectedType.admin_type_id &&
                      "selected-type"
                    }`}
                  >
                    <div className="request-type-icon">
                      <Image
                        height="100%"
                        width="100%"
                        fit="contain"
                        duration={800}
                        src={
                          type.admin_type_id === 1
                            ? EXPERT
                            : type.admin_type_id === 2
                            ? BRAND
                            : CENTRE
                        }
                        alt=""
                      />
                    </div>
                    <div style={{ fontWeight: "500" }}>
                      {type.admin_type_name === "expert" ? (
                        <>I'm a professional expert</>
                      ) : type.admin_type_name === "brand" ? (
                        <>I'm a product brand</>
                      ) : (
                        <>I'm a studio / centre</>
                      )}
                    </div>
                  </div>
                </div> */}
                {/* {type.admin_type_id !== 1 && ( */}

                <div
                  style={
                    // type.admin_type_id === selectedType.admin_type_id
                    //   ?
                    {
                      height: "118px",
                      opacity: 1,
                      overflow: "visible",
                      transition: "all 0.2s ease-in-out",
                    }
                    // : {
                    //     height: "0px",
                    //     opacity: 0,
                    //     overflow: "hidden",
                    //     transition: "all 0.2s ease-in-out",
                    //   }
                  }
                >
                  <span style={{ fontSize: "1em" }}>
                    {/* {type.admin_type_id === 2 */}
                    {/* ?  */}
                    Add brand name
                    {/* // : "Add centre name" */}
                  </span>
                  {/* {type.admin_type_id === 2 ? ( */}
                  <TextField
                    className="form-input"
                    label="Brand Name"
                    value={brandName}
                    onChange={(e) => {
                      setError({
                        ...error,
                        brandName: e.target.value ? false : true,
                      });
                      setBrandName(e.target.value);
                    }}
                    error={error.brandName}
                    helperText={
                      error.brandName ? "Please enter brand name" : " "
                    }
                    disabled={verifying}
                    style={{ margin: "0.5rem 0rem" }}
                    placeholder="Ex. Abc Xyz"
                    fullWidth
                  />
                </div>
                {/* )} */}
              </div>
              {/* // ))} */}
            </div>
          </div>
        ) : userType === "centre" ? (
          <div
            className="onboarding-step onboarding-step-2"
            style={{ padding: "1.5rem", color: "#CFCFCF" }}
          >
            <p
              style={{
                margin: "20px 0 40px 0",
                fontSize: "24px",
                fontWeight: 600,
                textAlign: "center",
              }}
            >
              Enter the centre name
            </p>
            <div style={{ margin: "1rem 0" }}>
              {/* {types.map((type, index) => ( */}
              <div
                // key={type.admin_type_id}
                style={{ marginBottom: "2rem" }}
              >
                {/* <div
                  style={{
                    margin: "1rem 0px",
                    borderRadius: "8px",

                    background:
                      "linear-gradient(152.68deg, #FFFFFF 5.46%, rgba(255, 255, 255, 0) 32.84%, rgba(255, 255, 255, 0) 71.3%, #FFFFFF 100%)",
                    padding: "1px",
                  }}
                >
                  <div
                    style={{
                      color:
                        type.admin_type_id === selectedType.admin_type_id
                          ? "#272727"
                          : "#FFFFFF",

                      margin: 0,

                      // background:type.admin_type_id === selectedType.admin_type_id"#1f1f1f":
                    }}
                    onClick={() => setSelectedType(type)}
                    className={`request-type ${
                      type.admin_type_id === selectedType.admin_type_id &&
                      "selected-type"
                    }`}
                  >
                    <div className="request-type-icon">
                      <Image
                        height="100%"
                        width="100%"
                        fit="contain"
                        duration={800}
                        src={
                          type.admin_type_id === 1
                            ? EXPERT
                            : type.admin_type_id === 2
                            ? BRAND
                            : CENTRE
                        }
                        alt=""
                      />
                    </div>
                    <div style={{ fontWeight: "500" }}>
                      {type.admin_type_name === "expert" ? (
                        <>I'm a professional expert</>
                      ) : type.admin_type_name === "brand" ? (
                        <>I'm a product brand</>
                      ) : (
                        <>I'm a studio / centre</>
                      )}
                    </div>
                  </div>
                </div> */}
                {/* {type.admin_type_id !== 1 && ( */}

                <div
                  style={
                    // type.admin_type_id === selectedType.admin_type_id
                    //   ?
                    {
                      height: "118px",
                      opacity: 1,
                      overflow: "visible",
                      transition: "all 0.2s ease-in-out",
                    }
                    // : {
                    //     height: "0px",
                    //     opacity: 0,
                    //     overflow: "hidden",
                    //     transition: "all 0.2s ease-in-out",
                    //   }
                  }
                >
                  <span style={{ fontSize: "1em" }}>
                    {/* {type.admin_type_id === 2 */}
                    {/* ?  */}
                    Add centre name
                    {/* // : "Add centre name" */}
                  </span>
                  {/* {type.admin_type_id === 2 ? ( */}
                  <TextField
                    className="form-input"
                    label="Centre Name"
                    value={centreName}
                    onChange={(e) => {
                      setError({
                        ...error,
                        centreName: e.target.value ? false : true,
                      });
                      setCentreName(e.target.value);
                    }}
                    error={error.centreName}
                    helperText={
                      error.centreName ? "Please enter centre name" : " "
                    }
                    disabled={verifying}
                    style={{ margin: "0.5rem 0rem" }}
                    placeholder="Ex. Abc Xyz"
                    fullWidth
                  />
                </div>
                {/* )} */}
              </div>
              {/* // ))} */}
            </div>
          </div>
        ) : (
          <div
            className="onboarding-step onboarding-step-2"
            style={{ padding: "1.5rem", color: "#CFCFCF" }}
          >
            <p
              style={{
                margin: "20px 0 40px 0",
                fontSize: "24px",
                fontWeight: 600,
                textAlign: "center",
              }}
            >
              Select type of <br />
              business.
            </p>
            <div style={{ margin: "1rem 0" }}>
              {types.map((type, index) => (
                <div
                  key={type.admin_type_id}
                  style={index === 0 ? { marginBottom: "2rem" } : null}
                >
                  <div
                    style={{
                      margin: "1rem 0px",
                      borderRadius: "8px",

                      background:
                        "linear-gradient(152.68deg, #FFFFFF 5.46%, rgba(255, 255, 255, 0) 32.84%, rgba(255, 255, 255, 0) 71.3%, #FFFFFF 100%)",
                      padding: "1px",
                    }}
                  >
                    <div
                      style={{
                        color:
                          type.admin_type_id === selectedType.admin_type_id
                            ? "#272727"
                            : "#FFFFFF",

                        margin: 0,

                        // background:type.admin_type_id === selectedType.admin_type_id"#1f1f1f":
                      }}
                      onClick={() => setSelectedType(type)}
                      className={`request-type ${
                        type.admin_type_id === selectedType.admin_type_id &&
                        "selected-type"
                      }`}
                    >
                      <div className="request-type-icon">
                        <Image
                          height="100%"
                          width="100%"
                          fit="contain"
                          duration={800}
                          src={
                            type.admin_type_id === 1
                              ? EXPERT
                              : type.admin_type_id === 2
                              ? BRAND
                              : CENTRE
                          }
                          alt=""
                        />
                      </div>
                      <div style={{ fontWeight: "500" }}>
                        {type.admin_type_name === "expert" ? (
                          <>I'm a professional expert</>
                        ) : type.admin_type_name === "brand" ? (
                          <>I'm a product brand</>
                        ) : (
                          <>I'm a studio / centre</>
                        )}
                      </div>
                    </div>
                  </div>
                  {type.admin_type_id !== 1 && (
                    <div
                      style={
                        type.admin_type_id === selectedType.admin_type_id
                          ? {
                              height: "118px",
                              opacity: 1,
                              overflow: "visible",
                              transition: "all 0.2s ease-in-out",
                            }
                          : {
                              height: "0px",
                              opacity: 0,
                              overflow: "hidden",
                              transition: "all 0.2s ease-in-out",
                            }
                      }
                    >
                      <span style={{ fontSize: "1em" }}>
                        {type.admin_type_id === 2
                          ? "Add brand name"
                          : "Add centre name"}
                      </span>
                      {type.admin_type_id === 2 ? (
                        <TextField
                          className="form-input"
                          label="Brand Name"
                          value={brandName}
                          onChange={(e) => {
                            setError({
                              ...error,
                              brandName: e.target.value ? false : true,
                            });
                            setBrandName(e.target.value);
                          }}
                          error={error.brandName}
                          helperText={
                            error.brandName ? "Please enter brand name" : " "
                          }
                          disabled={verifying}
                          style={{ margin: "0.5rem 0rem" }}
                          placeholder="Ex. Abc Xyz"
                          fullWidth
                        />
                      ) : type.admin_type_id === 3 ? (
                        <TextField
                          className="form-input"
                          label="Centre Name"
                          value={centreName}
                          onChange={(e) => {
                            setError({
                              ...error,
                              centreName: e.target.value ? false : true,
                            });
                            setCentreName(e.target.value);
                          }}
                          error={error.centreName}
                          helperText={
                            error.centreName ? "Please enter centre name" : " "
                          }
                          disabled={verifying}
                          style={{ margin: "0.5rem 0rem" }}
                          placeholder="Ex. Abc Xyz"
                          fullWidth
                        />
                      ) : null}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )
      ) : step === 3 ? (
        <About
          onBoardingUser={onBoardingUser}
          aboutObj={aboutObj}
          setAboutObj={setAboutObj}
          step={step}
          setStep={setStep}
          verifying={verifying}
          setVerifying={setVerifying}
        />
      ) : step === 4 ? (
        <Interests
          onBoardingUser={onBoardingUser}
          selectedSubTypes={selectedSubTypes}
          setSelectedSubTypes={setSelectedSubTypes}
          step={step}
          setStep={setStep}
          verifying={verifying}
          setVerifying={setVerifying}
          updateCustomerHandler={updateCustomerHandler}
        />
      ) : step === 5 ? (
        <ExpertDetails
          questions={questions}
          verifying={verifying}
          index={questionIndex}
          setIndex={setQuestionIndex}
          data={onBoardingData}
          setOnBoardingData={setOnBoardingData}
          updateProfile={updateProfile}
          typeIndex={typeIndex}
          setTypeIndex={setTypeIndex}
          type={type}
          setUserStep={setStep}
        />
      ) : step === 6 ? (
        <StageOneComplete
          onBoardingUser={onBoardingUser}
          step={step}
          setStep={setStep}
          verifying={verifying}
          setVerifying={setVerifying}
        />
      ) : step === 7 ? (
        <HealthQuestions
          onBoardingUser={onBoardingUser}
          healthQuestions={healthQuestions}
          setHealthQuestions={setHealthQuestions}
          step={step}
          setStep={setStep}
          verifying={verifying}
          setVerifying={setVerifying}
        />
      ) : step === 8 ? (
        <HealthScore
          onBoardingUser={onBoardingUser}
          step={step}
          setStep={setStep}
          verifying={verifying}
          setVerifying={setVerifying}
          getHealthScoreHandler={getHealthScoreHandler}
          score={score}
          setScore={score}
          scorePercentage={scorePercentage}
          setScorePercentage={setScorePercentage}
          tag={tag}
          setTag={setTag}
        />
      ) : step === 9 ? (
        <DownloadApp
          data={onBoardingData}
          onBoardingUser={onBoardingUser}
          setOnboardingUser={setOnboardingUser}
          step={step}
          setStep={setStep}
          selectedSubTypes={selectedSubTypes}
          score={score}
          setScore={score}
          scorePercentage={scorePercentage}
          setScorePercentage={setScorePercentage}
          tag={tag}
          setTag={setTag}
        />
      ) : (
        <></>
      )}
      {(step === 1 || step === 2) && (
        <div className="request-footer-btn">
          <Button
            id="step-4-onboarding"
            disabled={
              verifying ||
              (selectedType.admin_type_id === 1
                ? false
                : selectedType.admin_type_id !== 1
                ? brandName !== "" || centreName !== ""
                  ? false
                  : true
                : true)
              // ||
              // (selectedType.admin_type_id !== 1 &&
              //   (brandName === "" || centreName === ""))

              // verifying ||
              // (selectedType.admin_type_id === 2 && brandName === "") ||
              // (selectedType.admin_type_id === 3 && centreName === "")
            }
            onClick={() =>
              step === 1
                ? stepOneHandler()
                : step === 2
                ? accountTypeSubmitHandler(brandName, centreName)
                : createCustomerHandler()
            }
            // onClick={() => {
            //   if (selectedType.admin_type_id === 1) {
            //     accountTypeSubmitHandler()
            //   }
            //   else {
            //     setTypeIndex(typeIndex + 1);
            //   }
            // }}
            fullWidth
            variant="contained"
            size="large"
            style={{
              padding: "16px 0",
              fontSize: "1em",
              background:
                verifying ||
                (selectedType.admin_type_id === 1
                  ? false
                  : selectedType.admin_type_id !== 1
                  ? brandName !== "" || centreName !== ""
                    ? false
                    : true
                  : true)
                  ? "#383838"
                  : "linear-gradient(91.75deg, #FFFFFF 0.11%, #C4C4C4 100.1%)",
              color:
                verifying ||
                (selectedType.admin_type_id === 1
                  ? false
                  : selectedType.admin_type_id !== 1
                  ? brandName !== "" || centreName !== ""
                    ? false
                    : true
                  : true)
                  ? "#232323"
                  : "#FF4A01",
            }}
          >
            {verifying ? "Submitting..." : "Continue"}
          </Button>
        </div>
      )}
    </>
  );
}
